const getENV = () => {
    return {
        reactAppMode : process.env.REACT_APP_MODE,
        reactAppApiServerHost: process.env.REACT_APP_API_SERVER_HOST,
        reactAppApiServerPort: process.env.REACT_APP_API_SERVER_PORT,
        reactAppApiUrl: process.env.REACT_APP_API_URL,
        reactAppApiService: process.env.REACT_APP_API_SERVICE,
        reactAppApiTransactionService: process.env.REACT_APP_API_TRANSACTION_SERVICE,
        reactAppApiGetMerchantDetailsService:process.env.REACT_APP_API_GET_MERCHANT_SERVICE,
        reactAppApi3DSecureCardinalService : process.env.REACT_APP_API_3D_SECURE_CARDINAL_SERVICE,
        reactAppApiCardinalService: process.env.REACT_APP_API_CARDINAL_SERVICE
    }
}

const getSenitizedENV = (env) => {
    for (let [key, value] of Object.entries(env)) {
        if (value === undefined || value === "") {
            throw new Error(`Value of ${key.split(/(?=[A-Z])/).join("_").toUpperCase()} is missing`);
        }
    }
    return env;
};

const senitizedENV = getSenitizedENV(getENV());

const CONFIGS = {
    MODE: senitizedENV.reactAppMode,
    API: {
        HOST: senitizedENV.reactAppApiServerHost,
        PORT: senitizedENV.reactAppApiServerPort,
        URL: senitizedENV.reactAppApiUrl,
        SERVICE: senitizedENV.reactAppApiService,
        TRANSACTION_SERVICE: senitizedENV.reactAppApiTransactionService,
        GET_MERCHANT_DETAILS_SERVICE:senitizedENV.reactAppApiGetMerchantDetailsService,
        THREED_SECURE_CARDINAL_SERVICE: senitizedENV.reactAppApi3DSecureCardinalService,
        CARDINAL_SERVICE : senitizedENV.reactAppApiCardinalService
    }
}

export default CONFIGS;